// Real service areas from airteknc.com
const cities = [
  'Dunn', 'Spring Lake', 'Fayetteville', 'Hope Mills', 'Rockfish', 'Raeford',
  'Parkton', 'Lumber Bridge', 'Red Springs', 'Saint Pauls', 'Lumberton', 'Elizabethtown',
];

const counties = [
  'Cumberland County', 'Robeson County', 'Hoke County', 'Bladen County', 'Harnett County',
];

export default function ServiceAreas() {
  return (
    <section id="service-areas" className="bg-[#0a1628] py-24">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="text-center mb-12">
          <span className="text-[#00d4ff] text-xs font-bold tracking-widest uppercase">Where We Serve</span>
          <h2
            className="text-4xl md:text-5xl font-bold text-white mt-3 mb-4"
            style={{ fontFamily: 'Outfit, sans-serif' }}
          >
            Serving Southern NC Communities
          </h2>
          <p className="text-[#9ca3af] text-lg max-w-xl mx-auto">
            HVAC services in Fayetteville, Hope Mills, Lumberton, and all surrounding Southern NC areas.
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-10 items-start">
          {/* Left */}
          <div className="lg:w-[42%]">
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-2.5 mb-6">
              {cities.map((city) => (
                <div
                  key={city}
                  className="flex items-center gap-2 bg-[#1a2535] rounded-lg px-3 py-2.5 border border-white/5 hover:border-[#00d4ff]/25 transition-all duration-200"
                >
                  <div className="w-4 h-4 flex items-center justify-center shrink-0">
                    <i className="ri-map-pin-2-line text-[#00d4ff] text-xs" />
                  </div>
                  <span className="text-white text-xs font-medium whitespace-nowrap">{city}</span>
                </div>
              ))}
            </div>

            <div className="flex flex-wrap gap-2 mb-6">
              {counties.map((c) => (
                <span
                  key={c}
                  className="bg-[#00d4ff]/10 border border-[#00d4ff]/20 text-[#00d4ff] text-xs font-medium px-3 py-1 rounded-full"
                >
                  {c}
                </span>
              ))}
            </div>

            <div className="bg-[#1a2535] border border-[#00d4ff]/15 rounded-xl p-5">
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 flex items-center justify-center shrink-0">
                  <i className="ri-map-2-line text-[#00d4ff] text-xl" />
                </div>
                <div>
                  <h4 className="text-white font-bold text-sm mb-1">And All Surrounding Areas!</h4>
                  <p className="text-[#9ca3af] text-sm leading-relaxed">
                    Not sure if we cover your area? Call us at{' '}
                    <a href="tel:9193489399" className="text-[#00d4ff] font-medium cursor-pointer">
                      (919) 348-9399
                    </a>{' '}
                    — we&apos;re available 24/7 and happy to help.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Right: Real Google My Maps embed from airteknc.com */}
          <div className="lg:w-[58%] w-full">
            <div className="w-full h-[420px] rounded-2xl overflow-hidden border border-white/10">
              <iframe
                title="Air-Tek NC Service Area Map"
                src="https://www.google.com/maps/d/u/0/embed?mid=1MwyexIMLZANot1ktC-YS2mdVcpDNs_qS"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
